document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  const sections = document.querySelectorAll('[data-section-type="background-image"]');

  sections.forEach(section => {
    const overlay = section.querySelector('.background-media-text__overlay');

    if (!overlay) return;

    const heading = overlay.querySelector('h3');
    const paragraph = overlay.querySelector('p');

    // Animate title
    if (heading) {
      gsap.fromTo(
        heading,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: heading,
            start: 'top 85%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }

    // Animate subtitle
    if (paragraph) {
      gsap.fromTo(
        paragraph,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          delay: 0.15,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: paragraph,
            start: 'top 85%',
            toggleActions: 'play reverse play reverse',
          },
        }
      );
    }
  });
});
